export const trackEvent = event => {
  window.fathom && window.fathom.trackEvent(event)
}
